import { render, staticRenderFns } from "./EditAboutUs.vue?vue&type=template&id=ecefddfe&scoped=true&"
import script from "./EditAboutUs.vue?vue&type=script&lang=js&"
export * from "./EditAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecefddfe",
  null
  
)

export default component.exports